<template>
  <div class="flex gap-2.5 ml-5">
    <div
      v-for="cate in watchfaceWidgetCates"
      :key="cate"
      class="flex justify-center items-center flex-col hover:opacity-50 w-20"
      :class="{
        'opacity-50': editorStore.attrDisabled
      }"
      @click="handleTop(cate)"
    >
      <Icon
        :icon="menuIcons[cate] ?? 'menu.svg'"
        :width="20"
        :height="20"
        fill="none"
      />
      <span class="text-[12px] mt-[5px] opacity-70">{{
        cate === '数据' ? '其他' : cate
      }}</span>
    </div>
  </div>
  <modal-widget-list ref="widgetModalRef" />
</template>

<script lang="ts" setup>
import { useEditorStore } from '@/store/use-editor-store';
import {
  WatchfaceWidgetCate,
  watchfaceWidgetCates
} from '@/services/widget.service';
import { ref } from 'vue';

const menuIcons: Record<string, string> = {
  背景: 'menu.svg',
  时间: 'time.svg',
  日期: 'date.svg',
  数据: 'data.svg'
};

const editorStore = useEditorStore();

const widgetModalRef = ref();
const handleTop = (cate: WatchfaceWidgetCate) => {
  if (editorStore.attrDisabled) return;
  widgetModalRef.value?.open?.({ mode: cate });
};
</script>
